import { Button } from '@/components'
import type React from 'react'
import { useTranslation } from 'react-i18next'

interface RewardButtonProps {
  text: React.ReactNode
  onClick?: () => void
  disabled?: boolean
}

/** RewardButtonに必要なパラメータのみに絞ったButtonP */
const RewardButton = ({ text, onClick, disabled }: RewardButtonProps) => {
  return <Button text={text} width="w-9/12" onClick={onClick} disabled={disabled} />
}

interface RewardButtonWithStateProps {
  /** 応募期間内かどうか */
  inPeriod: boolean
  /** 在庫があるかどうか */
  isStock: boolean
  /** ? */
  checkCondition: boolean
  /** 0: None 1: Download 2: Product 3: Entry 4: Photo Frame 5: Coupon */
  presentType: Api.ConvertedPresentTypeId
  /** selectedPresentsDetailData. */
  selectedType: number
  /** 応募フォームがある場合 */
  isApplicationForm: number
}

export const RewardButtonWithState = ({
  inPeriod,
  isStock,
  checkCondition,
  selectedType,
  presentType,
  isApplicationForm,
}: RewardButtonWithStateProps) => {
  const { t } = useTranslation()

  /** 期間外の場合のボタン（期間外を一番最初に評価する） */
  if (!inPeriod) {
    return <RewardButton text={t('reward_detail.period_finished', '獲得期間外です')} disabled={true} />
  }
  /** 在庫がない場合のボタン（在庫の確認は2番目に評価する） */
  if (!isStock) {
    return (
      <>
        <RewardButton text={t('reward_detail.finished', '終了しました')} disabled={true} />
        <p className="mt-6 text-center text-sm font-bold">
          {t('reward_detail.thank_you_for_your_participation', 'たくさんのご参加ありがとうございました')}
        </p>
      </>
    )
  }
  /** 特典獲得条件（3番目に評価する） */
  if (!checkCondition) {
    // TODO このボタンにはもともとonClick属性がないのだけれど、呼ばれているか確認する
    //  それか常にdisabled=Trueになる？
    return (
      <RewardButton
        text={
          <>
            {selectedType === 3 ? t('reward_detail.lottery', '抽選する') : ''}
            {selectedType === 1 && presentType !== 'Coupon'
              ? isApplicationForm !== 0
                ? t('reward_detail.apply', '応募する')
                : t('reward_detail.receive_your_prize_1', '賞品をもらう')
              : ''}
            {selectedType !== 3 &&
              selectedType === 1 &&
              presentType === 'Coupon' &&
              t('reward_detail.coupon.use_this_coupon', 'クーポンを使う')}
          </>
        }
        // disabled={selectedBtnDisabled || selectedPresentsDetailData.userPresentItemName === null}
        disabled={true}
      />
    )
  }
  return <RewardButton text={''} onClick={() => {}} disabled={false} />
}
